import { Dashboard } from "@securitas/icons/mui";

export const Configuration = {
  appName: "Securitas One",
  baseUrl: process.env.PUBLIC_URL,
  appLogo: Dashboard,
};
